<div class="container">
  <h2 class="mb-4">進階設定</h2>

  <!-- 功能按鈕區 -->
  <div class="tool-buttons mb-4">
    <div class="row">
      <div class="col-md-4 mb-3" *ngFor="let tool of tools; let i = index">
        <div class="card h-100 tool-card" [class.active]="activeToolIndex === i" (click)="selectTool(i)">
          <div class="card-body text-center">
            <i class="fa" [ngClass]="tool.icon"></i>
            <h5 class="mt-2">{{ tool.name }}</h5>
            <p class="card-text small">{{ tool.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 工具區域 -->
  <div class="tool-content" *ngIf="activeToolIndex !== null">
    <!-- 既有資料匯入工具 -->
    <div *ngIf="activeToolIndex === 0" class="import-tool p-3 border rounded">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3>既有資料匯入工具</h3>
        <button class="btn btn-sm btn-outline-secondary" (click)="closeToolPanel()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- 文件上傳區 -->
      <div class="mb-3">
        <label for="fileUpload" class="form-label">上傳檔案 (XLSX)</label>
        <input type="file" class="form-control" id="fileUpload" accept=".xlsx" (change)="onFileSelected($event)">
        <div *ngIf="selectedFile" class="text-success mt-2">
          已選擇檔案: {{ selectedFile.name }}
        </div>
      </div>

      <!-- 必填及選填欄位 -->
      <div class="mb-3">
        <label for="topic" class="form-label">主題 <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="topic" [(ngModel)]="formData.topic" required>
      </div>

      <hr class="my-4">

      <div class="mb-3">
        <label for="title" class="form-label">任務名稱 <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="title" [(ngModel)]="formData.title" required>
      </div>

      <div class="mb-3 row">
        <div class="col-md-6">
          <label for="startDate" class="form-label">任務開始日期</label>
          <input type="date" class="form-control" id="startDate" [(ngModel)]="formData.startDate">
        </div>
        <div class="col-md-6">
          <label for="endDate" class="form-label">任務結束日期</label>
          <input type="date" class="form-control" id="endDate" [(ngModel)]="formData.endDate">
        </div>
      </div>

      <div class="mb-3">
        <label for="note" class="form-label">任務備註</label>
        <textarea class="form-control" id="note" rows="3" [(ngModel)]="formData.note"></textarea>
      </div>

      <!-- 提交按鈕 -->
      <div class="mb-3">
        <button class="btn btn-primary" (click)="submitForm()" [disabled]="isSubmitting || !selectedFile || !formData.topic || !formData.title">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" *ngIf="isSubmitting"></span>
          資料轉換
        </button>
      </div>

      <!-- 結果顯示 -->
      <div *ngIf="apiResponse" class="mt-4">
        <div class="alert" [ngClass]="apiResponse.success ? 'alert-success' : 'alert-danger'">
          <strong>{{ apiResponse.success ? '成功取得Excel資料內容' : '錯誤！' }}</strong>
          <p *ngIf="!apiResponse.success" class="mb-0">{{ apiResponse.message }}</p>
        </div>

        <!-- 匯入結果詳細資訊 -->
        <div *ngIf="apiResponse.success && apiResponse.data" class="mt-3 import-result-details">
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h5 class="mb-0">請確認以下內容，會在按下確認鍵之後正式寫入資料庫</h5>
            </div>
            <div class="card-body">
              <ol>
                <li>將 <strong>{{ apiResponse.data.law_list?.length || 0 }}</strong> 筆法規加入 <strong>{{ apiResponse.data.law_check_info?.topic }}</strong> 主題中。</li>
                <li>建立一份全新的判別任務，以下是該任務的詳細資訊
                  <ul class="mt-2">
                    <li><strong>任務名稱:</strong> {{ apiResponse.data.law_check_info?.title || '無' }}</li>
                    <li><strong>開始日期:</strong> {{ apiResponse.data.law_check_info?.startDate || '無' }}</li>
                    <li><strong>結束日期:</strong> {{ apiResponse.data.law_check_info?.endDate || '無' }}</li>
                    <li><strong>任務備註:</strong> {{ apiResponse.data.law_check_info?.note || '無' }}</li>
                  </ul>
                </li>
                <li>在該任務中，匯入針對 <strong>{{ apiResponse.data.law_list?.length || 0 }}</strong> 筆法規 <strong> 的 </strong><strong>{{ apiResponse.data.law_check_result?.length || 0 }}</strong> 筆判別結果</li>
              </ol>

              <div class="text-end mt-3">
                <button class="btn btn-secondary me-2" (click)="resetForm()">取消</button>
                <button class="btn btn-primary  me-2" (click)="downloadJson()" [disabled]="!apiResponse.data">
                  <i class="fa fa-download me-1"></i>下載JSON
                </button>
                <button class="btn btn-primary" (click)="InsertHistorydata()" [disabled]="isInserting">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" *ngIf="isInserting"></span>
                  確認寫入資料庫
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 設定鑑別群組工具 -->
    <div *ngIf="activeToolIndex === 1" class="identification-group-tool">
      <div class="d-flex justify-content-between align-items-center mb-3 p-3 border rounded">
        <h3>設定鑑別群組</h3>
        <button class="btn btn-sm btn-outline-secondary" (click)="closeToolPanel()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- 組織管理元件 -->
      <app-organization-management [assistantNo]="assistantNo"></app-organization-management>
    </div>
  </div>
</div>
